var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrivaPremiumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16169_26896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74935 1.16699L9.06359 2.56207C9.33017 3.74541 10.2542 4.66951 11.4376 4.93607L12.8327 5.25033L11.4376 5.56458C10.2542 5.83114 9.33017 6.75521 9.06359 7.93856L8.74935 9.33366L8.43511 7.93856C8.16852 6.75521 7.24447 5.83114 6.06112 5.56458L4.66602 5.25033L6.06112 4.93607C7.24441 4.66951 8.16852 3.74541 8.43511 2.56208L8.74935 1.16699Z",
    stroke: "#003E3E",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08268 7L4.30715 7.99651C4.49755 8.8417 5.15762 9.5018 6.00284 9.6922L6.99935 9.91667L6.00284 10.1411C5.15762 10.3315 4.49755 10.9916 4.30715 11.8368L4.08268 12.8333L3.85821 11.8368C3.66781 10.9916 3.00774 10.3315 2.16251 10.1411L1.16602 9.91667L2.16251 9.6922C3.00774 9.5018 3.66781 8.84176 3.85821 7.99651L4.08268 7Z",
    stroke: "#003E3E",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16169_26896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivaPremiumIcon);
export default __webpack_public_path__ + "static/media/triva_premium-icon.0449d62978a58fe0ff97181e3299ccca.svg";
export { ForwardRef as ReactComponent };